import { ListItemIcon } from "@mui/material";
import type React from "react";
import { BiBuilding, BiStore, BiUser } from "react-icons/bi";
import { SearchType } from "src/components/generics/nestedSelect/NestedSelect";

import { useEntityIconStyles } from "./EntityIcon.styles";

interface EntityIconProps {
    type: SearchType;
}

export const EntityIcon: React.FC<EntityIconProps> = ({ type }): JSX.Element => {
    const classes = useEntityIconStyles();

    return (
        <ListItemIcon classes={{ root: classes.root }}>
            {
                {
                    [SearchType.Organization]: <BiBuilding />,
                    [SearchType.PointOfSales]: <BiStore />,
                    [SearchType.User]: <BiUser />,
                }[type]
            }
        </ListItemIcon>
    );
};
